import React, { useState, useMemo, useEffect, useCallback } from "react";
import {
  Card,
  Spin,
  Tabs,
  Space,
  Button,
  Form,
  message,
  Typography,
  Radio,
  Popover,
} from "antd";
import {
  ArrowLeftOutlined,
  CloseOutlined,
  TeamOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";

// Components
import FormJudge1 from "../componentsEditJudgment/FormJudge1";
import FormJudge2 from "../componentsEditJudgment/FormJudge2";
import AddDefendantModal from "../../court/modalJudgment/AddDefendantModal";

// Hooks
import useJudgmentData from "../hooks/useJudgmentData";
import { contentPopOver } from "../hooks/ContentPopOver";

const { Title, Text } = Typography;

const CreateJudgment = ({ dataDefault, onClose, funcUpdateStatus }) => {
  const [form] = Form.useForm();
  const [formAddDefendant] = Form.useForm();

  // Custom Hook
  const {
    loading,
    setLoading,
    dataLoadGurantor,
    judgeData,
    lawsuitData,
    arothrData,
    checkboxTab1,
    checkboxTab2,
    allDefendants,
    guarantorsOnly,
    customerCustomerId,
    customerCustomerIdAll,
    nextGarno,
    userId,
    userName,
    loadGurantor,
    loadData,
    postStatus,
    addCustomerJudge,
    handleCheckboxTab1Change,
    handleCheckboxTab2Change,
    resetCheckboxes,
    saveFormDataTab1,
    getMergedFormData,
    formDataTab1,
    resetFormDataTab1,
    selectedDefendantsTab1,
    selectedDefendantsTab2,
  } = useJudgmentData({ dataDefault, form });

  // Local States

  const [radioDecide, setRadioDecide] = useState(null);
  const [tabsKey, setTabsKey] = useState();
  const [isModalAddDefendant, setIsModalAddDefendant] = useState(false);
  const [arrow, setArrow] = useState("Show");

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") return false;
    if (arrow === "Show") return true;
    return { pointAtCenter: true };
  }, [arrow]);

  // ✅ คำนวณ disabled defendants สำหรับแต่ละ Tab
  const disabledDefendantsTab1 = useMemo(() => {
    // Tab1 ไม่สามารถเลือกคนที่ถูกเลือกใน Tab2 แล้ว
    return checkboxTab2;
  }, [checkboxTab2]);

  const disabledDefendantsTab2 = useMemo(() => {
    // Tab2 ไม่สามารถเลือกคนที่ถูกเลือกใน Tab1 แล้ว
    return checkboxTab1;
  }, [checkboxTab1]);

  // ========================================
  // Auto-check ผู้เช่าซื้อใน Tab 1
  // ========================================

  useEffect(() => {
    loadGurantor();
    loadData();
  }, [loadGurantor, loadData]);

  useEffect(() => {
    console.log("judgeData", judgeData);
    setRadioDecide(judgeData?.loanNew ? "agreement" : "enforce");
    if (judgeData?.loanNew) {
      setTabsKey("1");
    }
    resetFormDataTab1();
  }, [judgeData, arothrData, lawsuitData, resetFormDataTab1]);

  useEffect(() => {
    if (customerCustomerId) {
      if (!checkboxTab1.includes(customerCustomerId)) {
        handleCheckboxTab1Change([...checkboxTab1, customerCustomerId]);
      }
    }
  }, [customerCustomerId, checkboxTab1, handleCheckboxTab1Change]);

  const onChangeCheckBoxAll = useCallback(
    (e) => {
      const value = e.target.checked;
      resetCheckboxes();
      if (radioDecide === "agreement" && value) {
        handleCheckboxTab1Change(customerCustomerIdAll);
      } else {
        handleCheckboxTab1Change([customerCustomerId]);
      }
    },
    [
      radioDecide,
      customerCustomerIdAll,
      customerCustomerId,
      resetCheckboxes,
      handleCheckboxTab1Change,
    ],
  );

  // ========================================
  // Event Handlers
  // ========================================

  const handleCancel = useCallback(() => {
    onClose();
  }, [onClose]);

  const onFinish = useCallback(
    async (values) => {
      try {
        console.log("Form Values:", values);
        console.log("Selected Defendants Tab1:", selectedDefendantsTab1);
        console.log("Selected Defendants Tab2:", selectedDefendantsTab2);
        console.log("Radio Decide:", radioDecide);

        let payload;
        let loanNewData;
        let payloadJudge;
        let judgeDefData = [];
        let payloadArothr = [];
        const newContnoUse =
          formDataTab1?.newContnoCustom || values?.newContnoCustom;

        // ✅ Derive ตอน submit แทนการพึ่ง selectedDefendantsTab1/2
        const resolvedTab1Objects = allDefendants.filter((defendant) =>
          checkboxTab1.includes(defendant.CUSTOMER_ID),
        );

        const resolvedTab2Objects = guarantorsOnly.filter((defendant) =>
          checkboxTab2.includes(defendant.CUSTOMER_ID),
        );
        // กรณี enforce
        if (radioDecide === "enforce") {
          // Tab1
          let defendantNumberValue = 0;

          if (
            (resolvedTab1Objects.length > 0 && formDataTab1) ||
            checkboxTab1.length > 0 ||
            (selectedDefendantsTab1 &&
              selectedDefendantsTab1.length > 0 &&
              formDataTab1)
          ) {
            console.log("resolvedTab1Objects", resolvedTab1Objects);
            let checkBoxValue =
              selectedDefendantsTab1 && selectedDefendantsTab1.length > 0
                ? selectedDefendantsTab1
                : resolvedTab1Objects;
            checkBoxValue.forEach((defendant) => {
              const isCustomer = defendant.type === "customer";
              console.log(formDataTab1);
              console.log("judgeData", judgeData);

              const matchedJudge = judgeData?.judgeDef.find(
                (item) => defendant.CUSTOMER_ID === item.customerId,
              );

              console.log("matchedJudge", matchedJudge);
              console.log("values===>", values);
              console.log("formDataTab1==>", formDataTab1);
              const tab1 = formDataTab1 || {};
              let costInterestLimit = null;
              if (values.delayCostUnless1 || tab1.delayCostUnless1) {
                if (
                  (values.costUnless1 || tab1.costUnless1) &&
                  (values.delayCostUnless1 || tab1.delayCostUnless1)
                ) {
                  costInterestLimit = Math.round(
                    parseFloat(
                      (tab1.costUnless1 || values.costUnless1) *
                        (tab1.interestRateCostUnless1 ||
                          values.interestRateCostUnless1) *
                        (tab1.delayCostUnless1 || values.delayCostUnless1),
                    ) / 365,
                  );
                }
              }

              const tab1Data = {
                idJudgeDef: matchedJudge?.idJudgeDef || 0,
                idJudge: judgeData?.idJudge || 0,
                loanId: dataDefault.loanId,
                lawsuitId: dataDefault.lawsuitId,
                CONTNO: dataDefault.CONTNO,
                customerId: defendant.CUSTOMER_ID,
                judgeNumber: 1,
                defendantNumber: defendantNumberValue + 1,
                newContno: newContnoUse,
                ref: isCustomer ? "001" : "002",
                TONBALANCE: parseFloat(
                  tab1.judgementLack1 || values.judgementLack1 || 0,
                )
                  ? parseFloat(
                      tab1.judgementLack1 || values.judgementLack1 || 0,
                    )
                  : parseFloat(tab1.judgement1 || values.judgement1 || 0),
                interestRate:
                  (tab1.interestRate1 || values.interestRate1) * 100 ||
                  (tab1.interestRateJudgeLack1 || values.interestRate1) * 100,
                interestLimit: null,
                delay: null,
                firstDate:
                  tab1.dateInterest1 || values.dateInterest1
                    ? dayjs(tab1.dateInterest1 || values.dateInterest1).format()
                    : null,

                costOfUselesenessPerMonth:
                  parseFloat(tab1.costPermonth1 || values.costPermonth1) ||
                  null,
                costOfUselessness: parseFloat(
                  tab1.costUnless1 || values.costUnless1 || 0,
                ),
                costRate:
                  (tab1.interestRateCostUnless1 ||
                    values.interestRateCostUnless1) * 100 || null,
                costInterestLimit: parseFloat(costInterestLimit || 0),
                costDelay:
                  tab1.delayCostUnless1 || values.delayCostUnless1 || null,
                costFirstDate:
                  tab1.dateInterestCostUnless1 || values.dateInterestCostUnless1
                    ? dayjs(
                        tab1.dateInterestCostUnless1 ||
                          values.dateInterestCostUnless1,
                      ).format()
                    : null,
                costSdatePerMonth:
                  tab1.datePermonthInterest1 || values.datePermonthInterest1
                    ? dayjs(
                        tab1.datePermonthInterest1 ||
                          values.datePermonthInterest1,
                      ).format()
                    : null,
                costOfUselesenessMonth:
                  tab1.costDay1 || values.costDay1 || null,

                trackingFee: parseFloat(
                  tab1.trackingFeeEnforce1 || values.trackingFeeEnforce1 || 0,
                ),
                attorneyFees: parseFloat(
                  tab1.lawyerFeeEnforce1 || values.lawyerFeeEnforce1 || 0,
                ),
                fee: parseInt(tab1.courtFee1 || values.courtFee1 || 0),
              };
              defendantNumberValue++;
              judgeDefData.push(tab1Data);
            });
          }

          // Tab2
          if (
            resolvedTab2Objects.length > 0 ||
            checkboxTab2.length > 0 ||
            (selectedDefendantsTab2 && selectedDefendantsTab2.length > 0)
          ) {
            let checkBoxValue =
              selectedDefendantsTab2 && selectedDefendantsTab2.length > 0
                ? selectedDefendantsTab2
                : resolvedTab2Objects;
            checkBoxValue.forEach((defendant) => {
              const isCustomer = defendant.type === "customer";
              const matchedJudge = judgeData?.judgeDef.find(
                (item) => defendant.CUSTOMER_ID === item.customerId,
              );
              let interestLimit2 = null;
              if (values.delayJudgement2) {
                if (values.judgementLack2 && values.interestRateLack2) {
                  interestLimit2 = Math.round(
                    parseFloat(
                      values.judgementLack2 *
                        values.interestRateLack2 *
                        values.delayJudgement2 || 0,
                    ) / 365,
                  );
                } else if (values.judgement2 && values.interestRate2) {
                  interestLimit2 = Math.round(
                    parseFloat(
                      values.judgement2 *
                        values.interestRate2 *
                        values.delayJudgement2 || 0,
                    ) / 365,
                  );
                }
              }

              let costInterestLimit2 = null;
              if (values.delayCostUnless2) {
                if (values.costUnless2 && values.delayCostUnless2) {
                  costInterestLimit2 = Math.round(
                    parseFloat(
                      values.costUnless2 *
                        values.interestRateCostUnless2 *
                        values.delayCostUnless2 || 0,
                    ) / 365,
                  );
                }
              }

              const tab2Data = {
                idJudgeDef: matchedJudge?.idJudgeDef || 0,
                idJudge: judgeData?.idJudge || 0,
                loanId: dataDefault.loanId,
                lawsuitId: dataDefault.lawsuitId,
                CONTNO: dataDefault.CONTNO,
                customerId: defendant.CUSTOMER_ID,
                judgeNumber: 2,
                defendantNumber: defendantNumberValue + 1,
                newContno: newContnoUse,
                ref: isCustomer ? "001" : "002",
                TONBALANCE: parseFloat(values.judgementLack2 || 0)
                  ? parseFloat(values.judgementLack2 || 0)
                  : parseFloat(values.judgement2 || 0),
                interestRate: values.interestRateLack2
                  ? values.interestRateLack2 * 100
                  : values.interestRate2
                    ? values.interestRate2 * 100
                    : null,
                interestLimit: parseFloat(interestLimit2 || 0),
                delay: values.delayJudgement2 || null,
                firstDate: values.dateInterest2
                  ? dayjs(values.dateInterest2).format()
                  : null,
                costOfUselesenessPerMonth:
                  parseFloat(values.costPermonth2 || 0) || null,
                costOfUselessness: parseFloat(values.costUnless2 || 0),
                costRate: values.interestRateCostUnless2 * 100 || null,
                costInterestLimit: parseFloat(costInterestLimit2 || 0),
                costDelay: values.delayCostUnless2 || null,
                costFirstDate: values.dateInterestCostUnless2
                  ? dayjs(values.dateInterestCostUnless2).format()
                  : null,
                costSdatePerMonth: values.datePermonthInterest2
                  ? dayjs(values.datePermonthInterest2).format()
                  : null,
                costOfUselesenessMonth: values.CostUnlessDay2 || null,
                trackingFee: parseFloat(values.trackingFeeEnforce2 || 0),
                attorneyFees: parseFloat(values.lawyerFeeEnforce2 || 0),
                fee: parseFloat(values.courtFee2 || 0),
              };
              defendantNumberValue++;
              judgeDefData.push(tab2Data);
            });
          }

          console.log("ไม่เท่ากัน", judgeDefData);
        } else {
          let defendantNumberValue = 0;

          // let checkBoxValue =
          //   resolvedTab1Objects && resolvedTab1Objects.length > 0
          //     ? resolvedTab1Objects
          //     : selectedDefendantsTab1;
          const checkBoxValue = allDefendants.filter((item) =>
            values.governmentOfficer1.includes(item.CUSTOMER_ID),
          );
          console.log("checkBoxValue", checkBoxValue);
          console.log("selectedDefendantsTab1", selectedDefendantsTab1);
          console.log("allDefendants", allDefendants);

          checkBoxValue.forEach((defendant) => {
            const isCustomer = defendant.type === "customer";
            const isCustomerId = defendant.CUSTOMER_ID;
            const matchedJudgeCustomer = judgeData?.judgeDef.find(
              (item) => defendant.CUSTOMER_ID === item.customerId,
            );

            const allPayData = {
              idJudgeDef: matchedJudgeCustomer?.idJudgeDef || 0,
              idJudge: judgeData?.idJudge || 0,
              loanId: dataDefault.loanId,
              lawsuitId: dataDefault.lawsuitId,
              CONTNO: dataDefault.CONTNO,
              customerId: isCustomerId,
              judgeNumber: 1,
              defendantNumber: defendantNumberValue + 1,
              newContno: newContnoUse,
              ref: isCustomer ? "001" : "002",

              TONBALANCE: parseFloat(values.paymentDue),
              interestRate: values.interestRateJudgeLack1 * 100 || null,

              interestLimit: null,
              delay: null,
              firstDate: values.dateInterest1
                ? dayjs(values.dateInterest1).format()
                : null,
              costOfUselesenessPerMonth: values.costPermonth1 || null,
              costOfUselessness: values.costUnless1 || null,
              costRate: values.interestRateCostUnless1 * 100 || null,
              costInterestLimit: null,
              costDelay: values.delayCostUnless1 || null,
              costFirstDate: values.dateInterestCostUnless1
                ? dayjs(values.dateInterestCostUnless1).format()
                : null,
              costSdatePerMonth: values.datePermonthInterest1
                ? dayjs(values.datePermonthInterest1).format()
                : null,
              costOfUselesenessMonth: values.costDay1 || null,

              trackingFee: values.trackingFeeEnforce1 || 0,
              attorneyFees: values.lawyerFeeEnforce1 || 0,
              fee: parseInt(values.courtFee1 || 0),

              // defendantName: `${defendant.SNAM}${defendant.NAME1} ${defendant.NAME2}`,
              // defendantType: defendant.type,
              // garno: defendant.garno,
            };
            defendantNumberValue++;
            judgeDefData.push(allPayData);
          });

          const customerValue = allDefendants.find((item) => item.garno === 0);
          console.log("customerValue", customerValue);

          loanNewData = {
            TOT_UPAY: parseFloat(values.paymentPerMonthAmount || 0), // ค่างวด
            T_NOPAY: parseInt(values.costMonth3 || 0), // จำนวนงวด
            NCSHPRC: parseFloat(values.paymentDue || 0), // ยอด
            LOAN_NEW_TONBALANCE: parseFloat(values.paymentDue || 0), // ยอด
            CUSTOMER_ID: customerValue.CUSTOMER_ID,
            FDATE: dayjs(values.dueDate).format(),
            SDATE: null,
            LDATE: dayjs(values.dueDate)
              .add(values.costMonth3 - 1, "month")
              .format(), // วันดิวสุดท้าย
            NEW_CONTNO: newContnoUse,
            ISSUNO: dataDefault.CONTNO,
            loan_new_id: judgeData?.loanNew?.loan_new_id || 0,
          };

          console.log("ทำยอม:", judgeDefData);
          console.log("allDefendants", allDefendants);
        }

        const NULLABLE_FIELDS = [
          "judgeNumber",
          "TONBALANCE",
          "interestRate",
          "interestLimit",
          "delay",
          "firstDate",
          "costOfUselesenessPerMonth",
          "costOfUselessness",
          "costRate",
          "costInterestLimit",
          "costDelay",
          "costFirstDate",
          "costSdatePerMonth",
          "costOfUselesenessMonth",
          "trackingFee",
          "attorneyFees",
          "fee",
        ];

        console.log("judgeDefData", judgeDefData);
        console.log("judgeData", judgeData);

        if (judgeData?.judgeDef) {
          // ✅ existing customerIds ใน judgeDef เดิม (เพื่อหาตัวใหม่ที่เพิ่มเข้ามา)
          const existingCustomerIds = new Set(
            judgeData.judgeDef.map((d) => d.customerId),
          );

          const mergedJudgeDef = judgeData.judgeDef.map((originalDef) => {
            const updatedDef = judgeDefData.find(
              (d) => d.customerId === originalDef.customerId,
            );

            if (updatedDef) {
              // ✅ มีใน judgeDefData → ใช้ค่าใหม่
              console.log("updatedDef (found)", updatedDef);
              return { ...updatedDef };
            } else {
              // ❌ ไม่มีใน judgeDefData → ใช้ค่าเดิม แต่ null NULLABLE_FIELDS
              const nulled = { ...originalDef };
              NULLABLE_FIELDS.forEach((field) => {
                nulled[field] = null;
              });
              console.log("nulled (not found)", nulled);
              return nulled;
            }
          });

          // ✅ หาตัวที่ถูกเพิ่มใหม่ใน judgeDefData แต่ไม่มีใน judgeDef เดิม
          const newEntries = judgeDefData.filter(
            (d) => !existingCustomerIds.has(d.customerId),
          );
          console.log("newEntries (added)", newEntries);

          judgeDefData = [...mergedJudgeDef, ...newEntries];
          console.log("judgeDefData------>", judgeDefData);
        }

        let definedCostPermonthValue = 0;

        if (formDataTab1?.costPermonth1 ?? values?.costPermonth1) {
          if (formDataTab1?.costDay1 ?? values?.costDay1 ?? 1) {
            definedCostPermonthValue =
              (formDataTab1?.costPermonth1 ?? values?.costPermonth1) *
              (formDataTab1?.costDay1 ?? values?.costDay1 ?? 1);
          } else {
            definedCostPermonthValue =
              (formDataTab1?.costPermonth1 ?? values?.costPermonth1) * 1;
          }
        }
        // สร้าง payload หลัก
        payloadJudge = {
          ...judgeData,
          idJudge: judgeData?.idJudge || 0,
          loanId: dataDefault.loanId,
          lawsuitId: dataDefault.lawsuitId,
          userId: userId,
          CONTNO: dataDefault.CONTNO,
          mark: values.memo || null,
          redCaseNumber: values.redNumber,
          judgeDate: dayjs(values.enforceCaseDate).format(),

          judgement: parseFloat(values.judgement1 || 0),
          judgeInterestRate: values.interestRate1 * 100 || null,

          judgementLack: parseFloat(values.judgementLack1 || 0),
          interestRate: values.interestRateJudgeLack1 * 100 || null,

          lackOfBenefits: parseFloat(values.costUnless1 || 0) || null,
          interestRateOfLack: values.interestRateCostUnless1 * 100 || null,
          LACK_BALANCE: parseFloat(values.costUnless1 || 0) || null,

          fee: parseFloat(values.courtFee1 || 0) || 0,
          trackingFee: parseFloat(values.trackingFeeEnforce1 || 0),
          attorneyFees: parseFloat(values.lawyerFeeEnforce1 || 0),

          copyingFee: null,
          trialMoneyCleared: null,
          suspensionAmount: null,

          AROTHR:
            radioDecide === "agreement"
              ? 0
              : parseFloat(values.courtFee1 || 0) +
                parseFloat(values.trackingFeeEnforce1 || 0) +
                parseFloat(values.lawyerFeeEnforce1 || 0) +
                definedCostPermonthValue,
          TONBALANCE:
            radioDecide === "agreement"
              ? parseFloat(values.paymentDue)
              : parseFloat(values.judgementLack1 || 0)
                ? parseFloat(values.judgementLack1 || 0)
                : parseFloat(values.judgement1 || 0),
          judgementInterest:
            parseFloat(values.judgementLack1 || 0) > 0 &&
            parseFloat(values.judgement1 || 0) >
              parseFloat(values.judgementLack1 || 0)
              ? Math.round(
                  parseFloat(values.judgement1 || 0) -
                    parseFloat(values.judgementLack1 || 0),
                )
              : 0,

          //เพิ่ม
          creditPercen:
            dataDefault.product === 1 || dataDefault.product === 3 ? 25 : 70,
          creditDebtor:
            radioDecide === "agreement"
              ? Math.round(
                  (parseFloat(values.judgement1 || 0) +
                    parseFloat(values.costUnless1 || 0) +
                    definedCostPermonthValue) *
                    ((dataDefault.product === 1 || dataDefault.product === 3
                      ? 25
                      : 70) /
                      100),
                )
              : Math.round(
                  (parseFloat(values.judgement1 || 0) +
                    parseFloat(values.costUnless1 || 0) +
                    parseFloat(values.courtFee1 || 0) +
                    parseFloat(values.trackingFeeEnforce1 || 0) +
                    parseFloat(values.lawyerFeeEnforce1 || 0) +
                    definedCostPermonthValue) *
                    ((dataDefault.product === 1 || dataDefault.product === 3
                      ? 25
                      : 70) /
                      100),
                ),
          judgeDef: judgeDefData,
          loanNew: loanNewData ? loanNewData : null,
          FDATE:
            radioDecide === "agreement"
              ? dayjs(values.dueDate).format()
              : dayjs(values.fDate).format(),
          newContno: newContnoUse,
        };

        // ค่าขาดประโยชน์รายเดือน
        const judgementInterestfilter5 = arothrData.find(
          (item) => item.PAYFOR === "555",
        );
        if (definedCostPermonthValue > 0 || judgementInterestfilter5) {
          if (judgementInterestfilter5) {
            console.log("555 = 2");
            let costPermonth1Value = {
              ...judgementInterestfilter5,
              PAYAMT: definedCostPermonthValue,
              USERID: userName,
              CONTNO: newContnoUse,
            };
            payloadArothr.push(costPermonth1Value);
          } else if (definedCostPermonthValue > 0) {
            console.log("555 = 1");

            let costPermonth1Value = {
              CONTNO: newContnoUse,
              idJudge: dataDefault.idJudge,
              PAYFOR: "555",
              PAYAMT: definedCostPermonthValue,
              USERID: userName,
            };
            payloadArothr.push(costPermonth1Value);
          }
        }

        //ดอกเบี้ยลอย
        const judgementInterestfilter4 = arothrData.find(
          (item) => item.PAYFOR === "444",
        );
        if (payloadJudge.judgementInterest > 0 || judgementInterestfilter4) {
          if (judgementInterestfilter4) {
            console.log("444 = 2");
            let judgementInterestValue = {
              ...judgementInterestfilter4,
              PAYAMT: payloadJudge.judgementInterest || 0,
              USERID: userName,
              CONTNO: newContnoUse,
            };
            payloadArothr.push(judgementInterestValue);
          } else if (payloadJudge.judgementInterest > 0) {
            console.log("444 = 1");

            let judgementInterestValue = {
              CONTNO: newContnoUse,
              idJudge: dataDefault.idJudge,
              PAYFOR: "444",
              PAYAMT: payloadJudge.judgementInterest,
              USERID: userName,
            };
            payloadArothr.push(judgementInterestValue);
          }
        }
        //ค่าฤชาศาล
        const judgementInterestfilter3 = arothrData.find(
          (item) => item.PAYFOR === "333",
        );
        if (payloadJudge.fee > 0 || judgementInterestfilter3) {
          console.log("judgementInterestfilter", judgementInterestfilter3);

          if (judgementInterestfilter3) {
            console.log("333 = 2");
            let judgementInterestValue = {
              ...judgementInterestfilter3,
              PAYAMT: payloadJudge.fee || 0,
              USERID: userName,
              CONTNO: newContnoUse,
            };
            payloadArothr.push(judgementInterestValue);
          } else if (payloadJudge.fee > 0) {
            console.log("333 = 1");
            let judgementInterestValue = {
              CONTNO: newContnoUse,
              idJudge: dataDefault.idJudge,
              PAYFOR: "333",
              PAYAMT: payloadJudge.fee,
              USERID: userName,
            };
            payloadArothr.push(judgementInterestValue);
          }
        }

        //ค่าทนาย
        const judgementInterestfilter2 = arothrData.find(
          (item) => item.PAYFOR === "222",
        );
        if (payloadJudge.attorneyFees > 0 || judgementInterestfilter2) {
          if (judgementInterestfilter2) {
            console.log("222 = 2");
            let judgementInterestValue = {
              ...judgementInterestfilter2,
              PAYAMT: payloadJudge.attorneyFees || 0,
              USERID: userName,
              CONTNO: newContnoUse,
            };
            payloadArothr.push(judgementInterestValue);
          } else if (payloadJudge.attorneyFees > 0) {
            console.log("222 = 1");
            let judgementInterestValue = {
              CONTNO: newContnoUse,
              idJudge: dataDefault.idJudge,
              PAYFOR: "222",
              PAYAMT: payloadJudge.attorneyFees,
              USERID: userName,
            };
            payloadArothr.push(judgementInterestValue);
          }
        }
        //ค่าติดตาม
        const judgementInterestfilter1 = arothrData.find(
          (item) => item.PAYFOR === "111",
        );
        if (payloadJudge.trackingFee > 0 || judgementInterestfilter1) {
          if (judgementInterestfilter1) {
            console.log("111 = 2");
            let judgementInterestValue = {
              ...judgementInterestfilter1,
              PAYAMT: payloadJudge.trackingFee || 0,
              USERID: userName,
              CONTNO: newContnoUse,
            };
            payloadArothr.push(judgementInterestValue);
          } else if (payloadJudge.trackingFee > 0) {
            console.log("111 = 1");
            let judgementInterestValue = {
              CONTNO: newContnoUse,
              idJudge: dataDefault.idJudge,
              PAYFOR: "111",
              PAYAMT: payloadJudge.trackingFee,
              USERID: userName,
            };
            payloadArothr.push(judgementInterestValue);
          }
        }

        payload = {
          arothr: payloadArothr,
          judge: payloadJudge,
          userId: userId,
        };

        console.log("📦 Payload:", payload);

        setLoading(true);
        const result = await postStatus(payload);

        if (result !== 200) {
          throw new Error("ไม่สามารถบันทึกข้อมูลได้");
        }

        if (funcUpdateStatus) {
          try {
            console.log("🔄 ขั้นตอนที่ 3: กำลังอัปเดทสถานะ...");
            await funcUpdateStatus();
            console.log("✅ ขั้นตอนที่ 3: อัปเดทสถานะสำเร็จ");
          } catch (updateError) {
            console.error("❌ อัปเดทสถานะล้มเหลว:", updateError);
            // ไม่ throw error เพราะข้อมูลหลักบันทึกสำเร็จแล้ว
          }
        }

        message.success({
          content: "บันทึกคำพิพากษาสำเร็จ",
          duration: 2,
        });

        // Delay เล็กน้อยเพื่อให้ user เห็น success message
        setTimeout(() => {
          handleCancel();
        }, 300);
      } catch (error) {
        console.error("❌ เกิดข้อผิดพลาด:", error);

        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง";

        message.error({
          content: errorMessage,
          duration: 4,
        });
      } finally {
        setLoading(false);
      }
    },
    [
      radioDecide,
      dataDefault,
      userId,
      selectedDefendantsTab1,
      selectedDefendantsTab2,
      allDefendants,
      postStatus,
      funcUpdateStatus,
      handleCancel,
      arothrData,
      checkboxTab1,
      checkboxTab2,
      formDataTab1,
      guarantorsOnly,
      judgeData,
      userName,
      setLoading,
    ],
  );
  const onFinishFailed = useCallback((errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครบถ้วน");
  }, []);

  const onChangeDecide = (e) => {
    const value = e.target.value;

    if (!dataLoadGurantor) {
      loadGurantor();
    }
    setRadioDecide(value);
    if (value === "agreement" || value === "enforceAllPay") {
      setTabsKey("1");
    }
    // form.setFieldsValue({ governmentOfficer1: [], governmentOfficer2: [] });
    // resetCheckboxes();
    resetFormDataTab1();
  };

  const onChangeDate = (date, dateString) => {
    console.log(date, dateString);
  };

  const onChangeDateAgreement = (date, dateString) => {
    console.log(date, dateString);
  };

  const handleTabChange = useCallback((key) => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    setTabsKey(key);
  }, []);

  // ========================================
  // Modal Handlers
  // ========================================

  const handleOpenAddDefendant = useCallback(() => {
    setIsModalAddDefendant(true);
    formAddDefendant.resetFields();
  }, [formAddDefendant]);

  const handleAddDefendant = async () => {
    try {
      const values = await formAddDefendant.validateFields();
      await addCustomerJudge(values);
      setIsModalAddDefendant(false);
      formAddDefendant.resetFields();
    } catch (error) {
      console.log("Add defendant failed:", error);
    }
  };

  // ========================================
  // Tabs Configuration
  // ========================================

  const tabItems = useMemo(() => {
    const items = [
      {
        key: "1",
        label: (
          <span style={{ fontSize: 16 }}>
            {radioDecide === "enforce"
              ? "คำพิพากษาจำเลยที่ ๑"
              : "คำพิพากษาจำเลย(ทำยอม)"}
          </span>
        ),
        children: (
          <FormJudge1
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            onChangeDate={onChangeDate}
            onChangeDateAgreement={onChangeDateAgreement}
            radioDecide={radioDecide}
            dataDefault={dataDefault}
            checkboxTab1={checkboxTab1}
            allDefendants={allDefendants}
            customerCustomerId={customerCustomerId}
            handleCheckboxTab1Change={handleCheckboxTab1Change}
            onAddDefendantClick={handleOpenAddDefendant}
            handleCancel={handleCancel}
            setTabsKey={setTabsKey}
            loading={loading}
            mergedArrow={mergedArrow}
            saveFormDataTab1={saveFormDataTab1}
            disabledDefendants={disabledDefendantsTab1} // ✅ เพิ่ม
            onChangeCheckBoxAll={onChangeCheckBoxAll}
          />
        ),
      },
    ];

    if (
      (dataDefault.LAW_TYPE_ID !== 2 || dataDefault.LAW_TYPE_ID !== 5) &&
      radioDecide === "enforce"
    ) {
      items.push({
        key: "2",
        label: <span style={{ fontSize: 16 }}>คำพิพากษาจำเลยถัดไป</span>,
        disabled: true,
        children: (
          <FormJudge2
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            onChangeDate={onChangeDate}
            checkboxTab2={checkboxTab2}
            guarantorsOnly={guarantorsOnly}
            handleCheckboxTab2Change={handleCheckboxTab2Change}
            onAddDefendantClick={handleOpenAddDefendant}
            handleCancel={handleCancel}
            setTabsKey={setTabsKey}
            loading={loading}
            mergedArrow={mergedArrow}
            getMergedFormData={getMergedFormData}
            formDataTab1={formDataTab1}
            disabledDefendants={disabledDefendantsTab2} // ✅ เพิ่ม
          />
        ),
      });
    }

    return items;
  }, [
    radioDecide,
    form,
    onFinish,
    onFinishFailed,
    dataDefault,
    checkboxTab1,
    checkboxTab2,
    allDefendants,
    guarantorsOnly,
    customerCustomerId,
    handleCheckboxTab1Change,
    handleCheckboxTab2Change,
    loading,
    mergedArrow,
    saveFormDataTab1,
    getMergedFormData,
    formDataTab1,
    disabledDefendantsTab1,
    disabledDefendantsTab2,
    handleCancel,
    handleOpenAddDefendant,
    onChangeCheckBoxAll,
  ]);

  // ========================================
  // Render
  // ========================================

  return (
    <div
      style={{
        padding: "12px",
        maxWidth: 1400,
        margin: "0 auto",
        minHeight: "100vh",
        background: "#f0f2f5",
      }}
    >
      <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
        <Card
          title={
            <Space align="center" size="large">
              <Button
                icon={<ArrowLeftOutlined />}
                onClick={handleCancel}
                type="text"
                size="large"
                style={{ fontSize: 16 }}
              >
                ย้อนกลับ
              </Button>
              <Title level={3} style={{ margin: 0 }}>
                {`แก้ไขคำพิพากษา: ${dataDefault?.CONTNO || ""}`}
              </Title>
            </Space>
          }
          extra={
            <Button
              danger
              onClick={handleCancel}
              size="large"
              icon={<CloseOutlined />}
            >
              ปิด
            </Button>
          }
          variant={false}
          style={{
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            borderRadius: 12,
          }}
        >
          {/* Radio - จำเลยประสงค์ */}

          <div style={{ marginBottom: 24 }}>
            <Text
              strong
              style={{ display: "block", marginBottom: 16, fontSize: 16 }}
            >
              <Popover
                content={contentPopOver("introduc")}
                title="คำแนะนำ"
                trigger="click"
              >
                <InfoCircleOutlined
                  style={{ color: "#1890ff", cursor: "pointer" }}
                />
              </Popover>{" "}
              จำเลยประสงค์ <TeamOutlined /> :
            </Text>
            <Radio.Group
              onChange={onChangeDecide}
              value={radioDecide}
              size="large"
              buttonStyle="solid"
              style={{ display: "flex", gap: 12, flexWrap: "wrap" }}
            >
              <Radio.Button
                value="enforce"
                style={{
                  height: 48,
                  lineHeight: "48px",
                  fontSize: 16,
                  minWidth: 200,
                  textAlign: "center",
                }}
                disabled={judgeData?.loanNew}
              >
                ⚖️ พิพากษา
              </Radio.Button>

              <Radio.Button
                value="agreement"
                style={{
                  height: 48,
                  lineHeight: "48px",
                  fontSize: 16,
                  minWidth: 200,
                  textAlign: "center",
                }}
              >
                🤝 ทำยอม (ประนีประนอม)
              </Radio.Button>
            </Radio.Group>
          </div>

          {/* Content */}
          <Tabs
            activeKey={tabsKey}
            onChange={handleTabChange}
            items={tabItems}
            size="large"
            centered
            tabBarStyle={{ marginBottom: 24 }}
            destroyOnHidden={false}
            disabled
          />
        </Card>
      </Spin>

      {/* Modal เพิ่มจำเลย */}
      <AddDefendantModal
        open={isModalAddDefendant}
        onCancel={() => {
          setIsModalAddDefendant(false);
          formAddDefendant.resetFields();
        }}
        onOk={handleAddDefendant}
        form={formAddDefendant}
        loading={loading}
        nextGarno={nextGarno}
        guarantorsLength={dataLoadGurantor?.guarantors?.length}
      />
    </div>
  );
};

export default CreateJudgment;
